"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingKitSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ShippingKitSearchResponse extends common_1.PaginatedResponse {
}
exports.ShippingKitSearchResponse = ShippingKitSearchResponse;
//# sourceMappingURL=shipping-kit-search.response.js.map